// import moment from "moment";
import { getCookie } from "./cookie"
export const setTitle = (title: string) => {
  document.title = title
}

// 浑天登录
export const goLogin = (url?: string) => {
  window.location.href = `//huntian.hzins.com/login?redirectUrl=${encodeURIComponent(
    url || window.location.href,
  )}`
}

export const pageToNewUrl = (url: string) => {
  window.location.href = url || window.location.href
}

export const openNewWindow = (
  url: string,
  title?: string,
  windowFeatures?: string,
) => {
  // window.location.href = url || window.location.href;
  window.open(url, title, windowFeatures)
}

export const loadScript = (url: string) => {
  return new Promise<void>((resolve, reject) => {
    const script: any = document.createElement("script")
    const load = () => {
      if (/loaded|complete/.test(script.readyState)) {
        script.onreadystatechange = null
      }
      resolve()
    }
    script.async = true
    script.onload = load
    script.onreadystatechange = load
    script.src = url
    if (document.body) {
      document.body.appendChild(script)
    } else {
      reject()
    }
  })
}
export const getUser = () => {
  const employeeWorkCode = getCookie("employeeWorkCode")
  const employeeName = getCookie("employeeName")
  const businessCenter = getCookie("businessCenter")
  const employeeJobCode = getCookie("employeeJobCode")
  const employeeDepartmentId = getCookie("employeeDepartmentId")
  const tenantCode = getCookie("tenantCode")
  const tenantType = getCookie("tenantType")
  /**
   * tenantCode
   * 慧择租户 100001
   * 齐欣租户 100003
   * 保芯租户 100005
   * 聚米租户 100007
   */

  return {
    tenantCode,
    businessCenter,
    employeeWorkCode,
    employeeName,
    employeeJobCode,
    employeeDepartmentId,
    tenantType,
  }
}
// 提交表单判空
const isEmpty = (value: string) =>
  value === null || value === undefined || value === ""
const placeholder = "--"

// 统一格式
export const dataFormat = (data?: any) => {
  if (isEmpty(data)) {
    return placeholder
  }
  return data
}

/**
 * @Description 提取当前url中的query参数并转化成对象
 * @author hz21087108
 * @date 2021-12-13
 * @returns {any}
 */
export const searchParse = () => {
  const resultObj: any = {}
  let search = window.location.search
  if (search && search.length > 1) {
    search = search.substring(1)
    let items = search.split("&")
    for (let index = 0; index < items.length; index++) {
      if (!items[index]) {
        continue
      }
      let kv = items[index].split("=")
      resultObj[kv[0]] = typeof kv[1] === "undefined" ? "" : kv[1]
    }
  }
  return resultObj
}

/**
 * @Description 字节大小转化为Kb/Mb
 * @author hz21087108
 * @date 2021-12-13
 * @param {any} limit:number
 * @returns {string} xMb/Kb
 */
export function getSizeStr(limit: number): string {
  let size = ""
  if (limit < 0.1 * 1024) {
    //小于0.1KB，则转化成B
    size = limit.toFixed(2) + "B"
  } else if (limit < 0.1 * 1024 * 1024) {
    //小于0.1MB，则转化成KB
    size = (limit / 1024).toFixed(2) + "KB"
  } else if (limit < 0.1 * 1024 * 1024 * 1024) {
    //小于0.1GB，则转化成MB
    size = (limit / (1024 * 1024)).toFixed(2) + "MB"
  } else {
    //其他转化成GB
    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
  }

  let sizeStr = String(size) //转成字符串
  let index = sizeStr.indexOf(".") //获取小数点处的索引
  let dou = sizeStr.substr(index + 1, 2) //获取小数点后两位的值
  if (dou == "00") {
    //判断后两位是否为00，如果是则删除00
    return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
  }
  return size
}

/**
 * @Description 网络图片转base64
 * @author hz21087108
 * @date 2021-12-13
 * @param {string} url
 * @param {(url: string) => void} cb
 * @returns {string} base64码
 */
export const imgToBase64 = (url: string, cb: Function) => {
  let canvas: any = document.createElement("canvas")
  let ctx: any = canvas.getContext("2d")
  let img = new Image()

  img.crossOrigin = "Anonymous"
  img.onload = function () {
    let dataURL
    canvas.height = img.height
    canvas.width = img.width
    ctx.drawImage(img, 0, 0)
    dataURL = canvas.toDataURL("image/png")
    cb && cb(dataURL)
    canvas = null
  }
  img.src = url
}
//base64转file对象
export const base64toFile = (base: string, filename: string) => {
  var arr: any[] = base.split(",")
  var mime = arr[0].match(/:(.*?);/)[1]
  var suffix = mime.split("/")[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  //转换成file对象
  return new File([u8arr], `${filename}.${suffix}`, { type: mime })
}
